import auctionsApi from '../../api/apiAuctions'

const state = {
    lot: ''
}
const getters = {
    getSingleLot: (state) => {
        return state.lot
    }
}

const mutations = {
    setSingleLot: (state, lotData) => {
        state.lot = lotData
    }
}

const actions = {
    fetchSingleLotData: ({ commit, dispatch }, lotId) => {
        dispatch('setStatusLoading')
        auctionsApi.getSingleLot(lotId)
            .then((response) => {
                commit('setSingleLot', response.data)
                dispatch('setStatusLoaded')
            })
            .catch(error => console.log(error))
    },
    setSingleLotData: ({ commit }, newData) => {
        commit('setSingleLot', newData)
    }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/singleLot.js